import { MedicalTerm } from '../../lib/types/models/medical-terms/medical-term'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getMedicalTerm(id: number) {
  return restApiClient.url(constructApiUrl(API.medicalTerms.get.url, { id })).get<MedicalTerm>()
}
